import { render, staticRenderFns } from "./CustomerIdentity.vue?vue&type=template&id=d7c6c174&"
import script from "./CustomerIdentity.vue?vue&type=script&lang=ts&"
export * from "./CustomerIdentity.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerIdentity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports